import React from "react";
import Typography from "@material-ui/core/Typography";
import images from "components/images";

export const SlotBasics = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Slot Basics</u>
      </Typography>
      <p>
        Each mission is made up of a number of slots, grouped into squads or
        fireteams. Each slot representing a possible player, their kit in a
        given mission and their position in the Orbat relative to other members.
      </p>
      <div className={"image"}>
        <img src={images["slots"]} alt={"slots"} />
      </div>
      <p>
        The Orbat above shows the relationship between different squads, with
        the Command team residing at the top of the chart and indiviual
        squads/fireteams below. As with many things in Combined Arms, the
        structure of the squads is up to the missionmakers discretion and thus
        can differ to the example shown above.
      </p>

      <Typography variant="h3" component="h2">
        On Hover
      </Typography>
      <p>
        Each slot at a glance will give you some basic information about the
        slot and the squad it resides in. Other information is present, such as
        the vehicle that the squad may possess the other members in the squad
        and what players have already reserved those slots.
      </p>

      <div className={"image"}>
        <img src={images["hover"]} alt={"hover"} />
      </div>
      <p>
        To get more information about a particular slot, simply hover over it
        with your cursor. A popup will automatically appear (shown above) with
        more details about the given slot such as the gear and any restrictions.
      </p>

      <p>Below is an example of all the states a slot can be in.</p>
      <div className={"image"}>
        <img
          style={{ width: "25%" }}
          src={images["slot_types"]}
          alt={"slot_types"}
        />
      </div>
      <p>
        The <strong>FTL</strong> slot is currently occupied by a user, and thus
        it's icon turns white and the player who has reserved the slot has their
        name displayed next to it.
      </p>
      <p>
        The <strong>MMG</strong> slot is an open slot, this slot is open for all
        members to join*.
      </p>

      <p>
        The <strong>AMMG</strong> slot is a locked slot. This means that no
        users can join this slot unless the missionmaker opens the slot
        manually. Locked slots are generally used to make the other squads fill
        up with players first and then are gradually opened as more people join.
      </p>

      <p>
        Lastly we have the <strong>RAT</strong> slot which is a raffle slot.
        These are generally reserved for special limited slot such as pilots or
        snipers that have a lot of interest with players in the community. While
        generally we have a first come first served policy a different stance
        has been taken with these positions. To be fair to all members of the
        community a raffle system has been implemented where players can reserve
        any other non locked or raffle slot and also enter into the raffle.
      </p>
      <p>
        When the missionmaker is ready they can resolve the raffle and the
        winning members will be automatically move from their current slots to
        the winning slot. There is a limit of one entry per user to each raffle
        slot, but no limits on the number of different raffle slots you can
        enter. For example, if there are 6 raffle slots in a given mission, you
        will be able to slot for, lets say, a basic rifleman slot and also put
        your name in for each of the 6 raffle slots.
      </p>
      <p style={{ fontSize: "10px" }}>
        *Not all users, if the slot is marked as "restricted" only members may
        take that slot. There is no visual difference between a restricted and
        non-restricted slot at a first glance. Hover over the slot to find out
        if it's restricted. Generally, only command/special slots are
        restricted.
      </p>
    </div>
  );
};

export default SlotBasics;
